import { Link } from 'react-router-dom';

const quickLinks = [
  { to: '/', label: '首页' },
  { to: '/category', label: '影视分类' },
  { to: '/search', label: '搜索' },
  { to: '/about', label: '关于我们' },
];

const categoryLinks = [
  { to: '/category?genre=武侠', label: '经典武侠' },
  { to: '/category?genre=悬疑', label: '热门悬疑' },
  { to: '/category?genre=奇幻', label: '奇幻冒险' },
  { to: '/category?genre=古装', label: '古装剧情' },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-primary-900 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className="ri-book-open-line text-lg"></i>
              </span>
              <span className="font-heading text-xl font-black tracking-wide">玉女心经2</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-7 text-background-200/90">
              专注影视作品的剧情介绍、角色信息与背景资料，为影迷提供专业、整洁、可检索的内容浏览体验。
            </p>
            <div className="mt-5 flex flex-wrap gap-3">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-800/70 px-3 py-1.5 text-xs text-background-200">
                <i className="ri-mail-line"></i> contact@yunuxinjing2.example
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-800/70 px-3 py-1.5 text-xs text-background-200">
                <i className="ri-time-line"></i> 内容每日更新
              </span>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-background-50">站内导航</h3>
            <ul className="mt-4 space-y-3">
              {quickLinks.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm text-background-200/90 transition-colors hover:text-accent-300"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-background-50">热门分类</h3>
            <ul className="mt-4 space-y-3">
              {categoryLinks.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm text-background-200/90 transition-colors hover:text-accent-300"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-800/80 pt-6 text-xs text-background-300/80 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2025 玉女心经2 影视内容站 · 本站内容为演示资料，仅供学习与浏览。</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-shield-check-line"></i> 专注影视资料 · 无登录与支付
          </p>
        </div>
      </div>
    </footer>
  );
}